import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { PochtaLocation } from './PochtaLocation'
/**
* Class UpdateOrderDeliveryPochta
*  Доставка Почта России: только ОПС назначения.
*/
export class UpdateOrderDeliveryPochta extends ActiveModel {

  /**
  * kind
  *   */
  @ActiveField({ readonly: true, value: () => 'Pochta' })
  readonly kind: string = 'Pochta'


  /**
  * deliveryMethodId
  * Идентификатор способа из каталога канала.  */
  @ActiveField(0)
  deliveryMethodId: number = 0


  /**
  * deliverTo
  * ОПС назначения (индекс обязателен).  */
  @ActiveField({
    factory: [PochtaLocation, () => undefined]
  })
  deliverTo?: PochtaLocation
}
